import React from "react";
import doctorImg from "../../assets/img/doctor.png";

const JobsIntro = () => {
  return (
    <section className="jobs_wrapper">
      <div className="jobs_container">
        {/* Left Text */}
        <div className="jobs_text">
          <h1 className="jobs_title">Join Our Team</h1>
          <h2 className="jobs_subtitle">Kangaroo Care Hospital</h2>

          <p>
            At Kangaroo Care Women and Children Hospital, we are committed to
            building a passionate team of professionals dedicated to
            transforming lives through exceptional care in women’s health, child
            wellness and fertility. We offer a dynamic and supportive work
            environment that encourages growth, continuous learning and
            innovation.
          </p>

          <p>
            Whether you’re an experienced specialist or beginning your journey
            in healthcare, you’ll find opportunities to sharpen your skills,
            collaborate with leading experts and make a meaningful impact in the
            lives of women, children and families.
          </p>

          <p>
            Our culture emphasizes teamwork, professional development and
            patient-centered care. By joining Kangaroo Care Women and Children
            Hospital, you become part of a community that values compassion,
            cutting-edge technology and excellence across all facets of care.
            Ready to make a difference? Discover our career opportunities and be
            a part of a mission that nurtures health and fulfills dreams.
          </p>
        </div>

        {/* Right Image */}
        <div className="jobs_image">
          <div className="image_circle">
            <img
              src={doctorImg}
              alt="Doctor"
              className="circle_img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobsIntro;
